/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@/config/apiConfig';
import { GET_TYPE_OF_APPLICATION } from '../../api/graphql';
import { applicationCardConfig } from '../../config/applicationCards.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IGetTypeOfApplicationMethods extends IPluginMethodMap {
  getTypeOfApplication(args: any): Promise<any>;
}

export class GetTypeOfApplicationService implements IAgentPlugin {
  readonly methods: IGetTypeOfApplicationMethods;

  constructor() {
    this.methods = {
      getTypeOfApplication: this.getTypeOfApplication.bind(this),
    };
  }

  async getTypeOfApplication(args: any) {
    console.log(`args in user lists service`, args);
    const storageService = StorageModule.getInstance();

    const localToken = storageService.get('myProfile', 'local');
    const sessionToken = storageService.get('myProfile', 'session');
    const vuid = localToken?.vuid ?? sessionToken?.vuid;
    console.log('po->', vuid);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_TYPE_OF_APPLICATION, {});
        if (res?.data?.getTypeOfApplicationForApplicant) {
          console.log(`table data222`, res);
          const data = res?.data?.getTypeOfApplicationForApplicant;
          const cards = applicationCardConfig.applicant.appCardList;
          return {
            appCardList: cards?.filter((item) =>
              data.includes(item?.appCardId)
            ),
          };
        } else {
          return {};
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }
}
